import { LoadScript } from "@react-google-maps/api";
import React from 'react';

import appConsts from "../utils/constants/appConsts";


const GoogleMapProvider = ({ children }) => {
    return (
        <LoadScript
            googleMapsApiKey={appConsts.googleMapsApiKey}
            libraries={['places']}
        >
            {children}
        </LoadScript>
    );
};

export  default GoogleMapProvider;
